import React, { useState, useEffect } from 'react';
import ReplyBox from 'routes/conversations/components/ReplyBox';
import { convertToRaw, convertFromRaw, EditorState } from 'draft-js';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import {
  GeckoCardWrapper,
  GeckoCardHeader,
  GeckoCardBody,
  GeckoCardFooter,
  GeckoBtnsSorted,
  GeckoToastService,
} from 'ui';
import { CONSTS } from 'constants/index.js';
import './index.scss';

function Signature({ signature, agentId }) {
  const [editorState, setEditorState] = useState(
    signature
      ? EditorState.createWithContent(convertFromRaw(signature))
      : EditorState.createEmpty()
  );
  const hasLocalContent = () =>
    editorState.getCurrentContent().getPlainText().length > 0;

  const updateSignature = () => {
    return GeckoRequest.post(`/agent/${agentId}/update-signature`, {
      signature: hasLocalContent()
        ? convertToRaw(editorState.getCurrentContent())
        : null,
    })
      .then(() => {
        new GeckoToastService().success('Signature updated');
      })
      .catch(renderError);
  };

  // We need to rekey the footerbuttons because UI does funky stuff with binding them
  const key = editorState.getCurrentContent().getPlainText();
  const footerBtns = [
    {
      type: 'default',
      name: 'Save',
      handler: updateSignature,
    },
  ];

  const updateCallbacks = {
    editorState: setEditorState,
  };

  return (
    <div className="Signature">
      <GeckoCardWrapper>
        <GeckoCardHeader name="Email Signature" />
        <GeckoCardBody padded>
          <ReplyBox
            editorMode={CONSTS.EDITOR_MODE_TYPE.SEMI_RICH}
            editorState={editorState}
            updateCallbacks={updateCallbacks}
            meta={{
              attachments: { show: true },
            }}
          />
        </GeckoCardBody>
        <GeckoCardFooter key={key}>
          <GeckoBtnsSorted items={footerBtns} />
        </GeckoCardFooter>
      </GeckoCardWrapper>
    </div>
  );
}

export default Signature;
